import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Flex, Image } from '@qga/roo-ui/components';

export const Card = styled(Flex)`
  padding: ${themeGet('space.4')};
  background: linear-gradient(-180deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 35%, #e6e6e6 100%);
  box-shadow: ${themeGet('shadows.hover')};
`;

export const CircleWithRoo = styled(Image)`
  height: ${themeGet('space.8')};
  width: ${themeGet('space.8')};
  border-radius: 50%;
  border: 2px black solid;
  padding: ${themeGet('space.1')};
  margin-right: ${themeGet('space.3')};
  margin-top: ${themeGet('space.2')};
`;
